export const ID_SUPPORT_DESC = "support_button_desc";
export const LANG = "lang";
